/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'
import {
	ConfigProvider,
  Layout,
  Input,
  Button,
  Radio,
  Checkbox,
  Select,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Divider,
  DatePicker,
  message,
  notification,
  Breadcrumb,
  Cascader,
  List,
  Popconfirm,
  Popover,
  Tag,
  Upload,
  Spin,
  Switch,
  InputNumber,
  Tree,
	TreeSelect,
	Steps,
	Dropdown,
	Menu,
	Badge,
  Rate,
  Pagination,
  Collapse,
  Empty,
  FormModel,
  TimePicker,
  Tooltip
} from 'ant-design-vue'
// import VueCropper from 'vue-cropper'

Vue.use(ConfigProvider)
Vue.use(Layout)
Vue.use(Input)
Vue.use(Button)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Form)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(Breadcrumb)
Vue.use(Cascader)
Vue.use(List)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Tag)
// Vue.use(VueCropper)
// @ts-ignore
Vue.use(notification)
Vue.use(Upload)
Vue.use(Spin)
Vue.use(Switch)
Vue.use(InputNumber)
Vue.use(Tree)
Vue.use(TreeSelect)
Vue.use(Steps)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Badge)
Vue.use(Rate)
Vue.use(Pagination)
Vue.use(Collapse)
Vue.use(Empty)
Vue.use(FormModel)
Vue.use(TimePicker)
Vue.use(Tooltip)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning
